module.exports = __webpack_public_path__ + "img/banner1.37a9fe5.png";